export default {
    sec1_0:{
        en:'Concept',
        tc:'概念',
        sc:'概念'
    },
    sec1_1:{
        en:'What is 21 WHITFIELD',
        tc:'第二十一威菲路酒店代表著',
        sc:'第二十一威菲路酒店代表着'
    },
    sec1_2:{
        en:'21 Whitfield is a four-star hotel\n located in Causeway Bay, Hong Kong, China',
        tc:'第二十一威菲路酒店是一家四星級酒店，位於中國香港銅鑼灣對於尋求活力都市度假的旅客來說，這裡是您理想的選擇。',
        sc:'第二十一威菲路酒店是一家四星级酒店，位于中国香港铜锣湾对于寻求活力都市度假的旅客来说，这里是您理想的选择。'
    },
    sec1_3:{
        en:'It is an ideal choice for travelers seeking a dynamic urban escape.\nTimes Square is only 579 metres away.',
        tc:'距離時代廣場僅 579 公尺。設有 24 小時接待櫃檯及快速辦理入住/退房服務，其便利性無與倫比。',
        sc:'距离时代广场仅 579 公尺。设有 24 小时接待柜台及快速办理入住/退房服务，其便利性无与伦比。'
    },
    sec1_4:{
        en:'With a 24-hour front desk and express check-in/check-out, the convenience is unmatched.\nSpacious room with air conditioning, free WiFi and impressive city or habour views.',
        tc:'提供免費 WiFi 以及令人印象深刻的城市或維港景。提供舒適難忘的住宿體驗。',
        sc:'提供免费 WiFi 以及令人印象深刻的城市或維港景。提供舒适难忘的住宿体验。'
    },
    sec1_5:{
        en:'Providing a comfortable and unforgettable accommodation experience.\nCultural attractions such as the Avenue of Stars and Happy Valley Racecourse can be visited nearby. Enjoy stunning harbour views from the rooftop, ideal for relaxing and exploring.',
        tc:'客人可以參觀附近的跑馬地馬場或星光大道等眾多文化景點。從頂層欣賞令人驚嘆的維港景色，非常適合於熱鬧的都市中心放鬆和探索。',
        sc:'客人可以参观附近的跑马地马场或星光大道等众多文化景点。从顶层欣赏令人惊叹的维港景色，非常适合于热闹的都市中心放松和探索。'
    },
    kc_text:{
        en:'key concept',
        tc:'核心概念',
        sc:'核心概念'
    },
    kc_viewMore:{
        en:'View more',
        tc:'查看更多',
        sc:'查看更多'
    },
    kc_0:{
        en:'key concept of 21 WHITFIELD',
        tc:'第二十一威菲路酒店的核心概念',
        sc:'第二十一威菲路酒店的核心概念'
    },
    kc_0_1:{
        en:'Here are four things guests can experience here',
        tc:'以下四點您可於酒店體驗到的核心概念',
        sc:'以下四点您可于酒店体验到的核心概念'
    },
    kc_1:{
        en:`The expansive Pacific Ocean before your eyes. \nAn open-air bath filled with natural hot spring water from the original source in all rooms. \nWaking up after a relaxing night's sleep on a prime-quality bed. \nGuests will find here the extraordinary amid which they can be themselves.`,
        tc:'廣闊的維多利亞海港呈現在眼前。\n所有客房均設有註入源頭天然溫泉水的露天浴池。\n在高品質的床上放鬆地熟睡。\n賓客將在這裡發現非凡的體驗並釋放自我。',
        sc:'广阔的维多利亚海港呈现在眼前。\n所有客房均设有注入源头天然温泉水的露天浴池。\n在高品质的床上放松地熟睡。\n宾客将在这里发现非凡的体验并释放自我。'
    },
    kc_2:{
        en:'Quality Japanese cuisine that fuses hospitality into traditional cookery. Guests are introduced to new styles of Japanese cuisine only TSUKUSHI can offer. \n A world yet to be realized.',
        tc:'高品質日本料理，將熱情好客與傳統烹飪融為一體。\n賓客將品嚐到全新風格的日本料理並於此探索味覺盛宴。',
        sc:'高品质日本料理，将热情好客与传统烹饪融为一体。\n宾客将品尝到全新风格的日本料理并于此探索味觉盛宴。'
    },
    kc_3:{
        en:'The facility signifying the essence of luxury sets the stage for relaxing private time. Space for executive training is also provided.',
        tc:'彰顯奢華精髓的設施，為放鬆的私人時光奠定了基礎。\n此外，酒店也提供行政管理培訓空間。',
        sc:'彰显奢华精髓的设施，为放松的私人时光奠定了基础。\n此外，酒店也提供高管培训空间。'
    },
    kc_4:{
        en:'Presenting a new way of spending time to enrich yourself during a trip. Are trips taken just for refreshing? We help guests improve their physical condition to lead an even healthier daily life.',
        tc:'提出一種新型消費模式\n讓您於旅行中充實自我。\n旅行不只是爲了放鬆，\n我們為住客提供健康及多方面享受的多元化住宿體驗。',
        sc:'提出一种新型消费模式\n让您于旅行中充实自我。\n旅行不只是为了放松，\n我们为住客提供健康及多方面享受的多元化住宿体验。'
    },
    ss_0:{
        en:'sightseeing',
        tc:'附近旅游景點',
        sc:'附近旅游景点'
    },
    ss_0_1:{
        en:'Explore Hong Kong',
        tc:'探索香港',
        sc:'探索香港'
    },
    ss_1:{
        en:'01. Causeway Bay (Shopping Area)',
        tc:'01. 銅鑼灣 (購物區)',
        sc:'01. 铜锣湾（购物区）'
    },
    ss_2:{
        en:'02. Hong Kong Convention & Exhibition Centre (Wanchai)',
        tc:'02. 香港會議展覽中心（灣仔）',
        sc:'02. 香港会议展览中心（湾仔）'
    },
    ss_3:{
        en:'03. Ngok Wong Temple',
        tc:'03. 岳王廟',
        sc:'03. 岳王庙'
    },
    ss_4:{
        en:'04. Oi! (North Point)',
        tc:'04. 油街 (北角)',
        sc:'04. 油街（北角）'
    },
    ss_5:{
        en:'05. The East Coast Park Precinct',
        tc:'05. 東岸公園區',
        sc:'05. 东岸公园小区'
    },
    ss_6:{
        en:'06. Victoria Park (Causeway Bay)',
        tc:'06. 維多利亞公園 (銅鑼灣)',
        sc:'06. 维多利亚公园（铜锣湾）'
    },
    ss_7:{
        en:'07. Causeway Bay Typhoon Shelter',
        tc:'07. 銅鑼灣避風塘',
        sc:'07. 铜锣湾避风塘'
    },
    ss_8:{
        en:'08. Eslite bookstore (Causeway Bay)',
        tc:'08. 誠品書店(銅鑼灣)',
        sc:'08. 诚品书店（铜锣湾）'
    },
    ss_9:{
        en:'09. Lin Fa Kung Temple (Tai Hang)',
        tc:'09. 大坑蓮花宮 (銅鑼灣)',
        sc:'09. 大坑蓮花宮（铜锣湾）'
    },
    ss_10:{
        en:'10. Tai Hang Fire Dragon Dance',
        tc:'10. 大坑舞火龍',
        sc:'10. 大坑舞火龍'
    },
    main_1_1:{
        en:`Causeway Bay is Hong Kong's energetic retail heart. Luxury malls, department stores and boutiques pack its western end, while bargain hunters roam the Jardine's Crescent street market. Numerous dining options, from upscale restaurants to street-food stalls, dot the area.The Hong Kong Convention and Exhibition Centre (HKCEC) is one of the two major convention and exhibition venues in Hong Kong, along with AsiaWorld-Expo. It is located in Wan Chai North, Hong Kong Island. Built along the Victoria Harbour, it is linked by covered walkways to nearby hotels and commercial buildings.`,
        tc:'銅鑼灣是香港充滿活力的零售中心，豪華商場集中地。百貨公司和精品店擠滿了西端，而尋找實惠商品的旅客可以在怡和新月街市集閒逛。眾多餐飲選擇，從高檔餐廳到街頭小吃攤，遍布整個地區。香港會議展覽中心（HKCEC）及亞洲國際博覽館是香港兩大會議展覽場地。位於香港島灣仔北。沿著維多利亞港而建，透過有蓋行人道與附近的酒店和商業建築相連。',
        sc:'铜锣湾是香港充满活力的零售中心，豪华商场集中地。百货公司和精品店挤满了西端，而寻找实惠商品的旅客可以在怡和新月街市集闲逛。众多餐饮选择，从高档餐厅到街头小吃摊，遍布整个地区。香港会议展览中心（HKCEC）及亚洲国际博览馆是香港两大会议展览场地。位于香港岛湾仔北。沿着维多利亚港而建，透过有盖行人道与附近的酒店和商业建筑相连。'
    },
    main_2_1:{
        en:`The Hong Kong Convention and Exhibition Centre (HKCEC) is one of the two major convention and exhibition venues in Hong Kong, along with AsiaWorld-Expo. It is located in Wan Chai North, Hong Kong Island. Built along the Victoria Harbour, it is linked by covered walkways to nearby hotels and commercial buildings.`,
        tc:'香港會議展覽中心（HKCEC）是香港兩大主要會議展覽場地之一。位於香港島灣仔北。沿著維多利亞港而建，透過有蓋走道與附近的酒店和商業建築相連。',
        sc:'香港会议展览中心（HKCEC）是香港两大主要会议展览场地之一。位于香港岛湾仔北。沿着维多利亚港而建，透过有盖走道与附近的酒店和商业建筑相连。'
    },
    main_3_1:{
        en:'Located in Electric Road of East Causeway Bay. It is the only temple dedicated to Yue Fei of the Southern Song dynasty in Hong Kong. Ngok Wong Temple has a history of nearly 100 years according to the legend. The festival of Ngok Wong, as well as the first and the 15th day of each month, attracts a large number of worshippers.',
        tc:'位於東銅鑼灣電氣道，該廟是香港唯一供奉南宋岳飛的廟宇。岳王廟相傳已有近百年歷史。岳王節及每月初一、十五，均吸引大批善信前來祈福。',
        sc:'位于东铜锣湾电气道，该庙是香港唯一供奉南宋岳飞的庙宇。岳王庙相传已有近百年历史。岳王节及每月初一、十五，均吸引大批善信前来祈福。'
    },
    main_4_1:{
        en:'Developed by the Leisure and Cultural Services Department, Oi! is a Hong Kong government art promotion organisation aiming to promote visual arts by providing a platform for art exhibitions, forums and other art-related activities. ',
        tc:'由康樂及文化事務署開發的「油街實現！」是香港政府藝術推廣組織旨在透過提供藝術展覽、論壇和其他藝術相關活動的平台。',
        sc:'由康乐及文化事务署开发的「油街实现！」是香港政府艺术推广组织旨在透过提供艺术展览、论坛和其他艺术相关活动的平台。'
    },
    main_5_1:{
        en:'The “East Coast Park Precinct” located at the harbourfront in North Point on Hong Kong Island consists of three parts. Phase 1 and breakwater were officially opened in September 2021 and Phase 1a was opened in December 2022 respectively. The Precinct occupies an area of about 1.1 hectares, with approximately 425-metre long promenade. In accordance with the principle of developing the harbourfront under the incremental approach and through the collaboration with various departments, certain part of the site can be released for public use ahead of schedule. \n Adopting the design concept of "Windows", the architect infused window frames of different sizes into the design of balustrades, outdoor installations and a low kerb, offering a distinctive scene for visitors as if it is being viewed through a window. A lawn area, benches, shelters, etc. are provided for public use. In addition, there is painting on the ground for children on balance bikes, while the architect has introduced slides and safety floor mats at part of the sloping seawall above the sea level in the Precinct. The Precinct is a pet-friendly site where pet owners and their pets on leashes are welcome to visit. The site is open to the public round the clock.',
        tc:'位於港島北角海濱的「東岸公園主題區」由三部分組成，分別為2021年9月開放的公園第一期和防波堤，及2022年12月開放的公園第一期甲， 總面積約1.1公頃，海濱長廊長約425米。主題區貫徹「先駁通、再優化」的海濱發展理念，透過各部門配合使部分用地能提早釋出讓公眾使用。\n\n項目以「窗戶」為設計概念，把大小不一的窗框融入欄杆、戶外裝置及矮壆的設計，遊人所見的景色仿似是從一扇窗向外望。主題區提供草地、座椅、遮陽設施等，供市民享用。另外，場地設有兒童平衡車試驗空間，亦於部分陸地斜面海堤上設置遊樂滑梯和安全地墊。主題區亦是寵物友善場地，歡迎市民帶同繫上牽繩的寵物到訪。主題區24小時開放。',
        sc:'位于港岛北角海滨的「东岸公园主题区」由三部分组成，分别为2021年9月开放的公园第一期和防波堤，及2022年12月开放的公园第一期甲， 总面积约1.1公顷，海滨长廊长约425米。主题区贯彻「先驳通、再优化」的海滨发展理念，透过各部门配合使部分用地能提早释出让公众使用。\n\n项目以「窗户」为设计概念，把大小不一的窗框融入栏杆、户外装置及矮壆的设计，游人所见的景色仿似是从一扇窗向外望。主题区提供草地、座椅、遮阳设施等，供市民享用。另外，场地设有儿童平衡车试验空间，亦于部分陆地斜面海堤上设置游乐滑梯和安全地垫。主题区亦是宠物友善场地，欢迎市民带同系上牵绳的宠物到访。主题区24小时开放。'
    },
    main_6_1:{
        en:'Opened in 1957, Victoria Park is the largest public park on Hong Kong Island. It occupies an area of 19 hectares and was named after the statue of Queen Victoria. Many events take place at Victoria Park on yearly basis such as Lunar New Year fair and Hong Kong flower show.',
        tc:'維多利亞公園於1957年啟用，是香港島最大的公園。它佔地19公頃，以維多利亞女王命名。維多利亞公園每年都會舉辦許多活動，例如農曆新年博覽會和香港花卉展。',
        sc:'维多利亚公园于1957年启用，是香港岛最大的公园。它占地19公顷，以维多利亚女王命名。维多利亚公园每年都会举办许多活动，例如农历新年博览会和香港花卉展。'
    },
    main_7_1:{
        en:'On the streets, the neon lights and electronic screens shine brightly. In this city center of Causeway Bay, where day and night blur together, you might not imagine watching a sunset here. However, in recent years, the typhoon shelter has become a great spot to enjoy the sunset in Causeway Bay. ',
        tc:'在街上，霓虹燈與螢幕璀璨奪目。位於銅鑼灣中心，白天和黑夜交織的地方，你可能無法想像在這裡看日落。然而近年來，避風塘已成為在銅鑼灣欣賞日落的絕佳地點。',
        sc:'街头，霓虹灯、电子萤幕璀璨夺目。在这个城市铜锣湾中心，白天和黑夜交织的地方，你可能无法想像在这里看日落。然而，近年来，避风塘已成为铜锣湾是欣赏日落的绝佳地点。'
    },
    main_8_1:{
        en:'Located in an international city full of vibrant economic energy, we aim to inspire the latent reading potential of the people of Hong Kong with new ideas and vibes. The space design emphasizes concepts of tranquility, subtlety, and quietness, featuring 100,000 titles and 300,000 books, making it the largest and most comprehensive bookstore in Hong Kong.',
        tc:'坐落於經濟活力四射的國際都市，誠品書店致力於以全新的理念和氛圍激發潛在的閱讀潛力。空間設計強調寧靜、細膩、靜謐，擁有10萬種書目、30萬冊藏書，是香港規模最大、內容最齊全的書店。',
        sc:'坐落于活力四射的国际化都市，诚品书店致力于以全新的理念和氛围激发潜在的阅读潜能。空间设计强调宁静、细腻、静谧，拥有10万种书目、30万册藏书，是香港规模最大、内容最齐全的书店。'
    },
    main_9_1:{
        en:'Causeway Bay Tin Hau Temple is located at 10 Tin Hau Temple Road. The Tin Hau Temple in Causeway Bay is listed as a declared monument in Hong Kong. It was built in the early Qing Dynasty and the history of the original temple can be traced back to 1747. Beinga famous must-see attraction in the area, Tin Hau MTR station is named after the temple.',
        tc:'銅鑼灣天后廟位於香港島銅鑼灣天后廟道10號。銅鑼灣天后廟被列作香港法定古蹟，建於清朝初年，原廟的歷史可追溯至1747年。天后地鐵站因該廟而命名，是該區著名必到景點。',
        sc:'铜锣湾天后庙位于香港岛铜锣湾天后庙道10号。铜锣湾天后庙被列作香港法定古迹，建于清朝初年，原庙的历史可追溯至1747年。天后地铁站因该庙而命名，是该区著名必到景点。'
    },
    main_10_1:{
        en:'A recognised National Intangible Cultural Heritage, the 67-metre fire dragon made of incense sticks is paraded by 300 performers, accompanied by a small dragon carried by children, continuing this tradition to draw crowds and showcase this neighbourhood’s cherished, time-honoured custom in Hong Kong',
        tc:'每年中秋節，大坑街頭都因舞火龍而熱鬧非凡。這項傳統可追溯至19世紀，當時居民以插滿線香的火龍驅趕疫症。時至今日，由300位健兒引領全長67米的火龍，以及由小朋友舞動的小火龍，會穿梭大坑的大街小巷。這份團結精神一直傳承，吸引眾多市民和遊客慕名前來觀賞，一睹這項國家級非物質文化遺產的魅力，體驗珍貴的香港傳統。',
        sc:'每年中秋节，大坑街头都因舞火龙而热闹非凡。这项传统可追溯至19世纪，当时居民以插满线香的火龙驱赶疫症。时至今日，由300位健儿引领全长67米的火龙，以及由小朋友舞动的小火龙，会穿梭大坑的大街小巷。这份团结精神一直传承，吸引众多市民和游客慕名前来观赏，一睹这项国家级非物质文化遗产的魅力，体验珍贵的香港传统。'
    },
    how_0:{
        en:'How to get to 21 WHITFIELD',
        tc:'如何到達第二十一威菲路酒店',
        sc:'如何到达第二十一威菲路酒店'
    },
    how_0_1:{
        en:'Access',
        tc:'訪問',
        sc:'访问'
    },
    how_1:{
        en:'By MTR → Tin Hau station → A2 exit.',
        tc:'港鐵 → 天后站 → A2 出口。',
        sc:'港铁 → 天后站 → A2 出口。'
    },
    how_2:{
        en:'→ About 5-10 mins walk along Electric Road',
        tc:'→ 沿電氣道步行約5-10分鐘',
        sc:'→ 沿电气道步行约5-10分钟'
    },
    how_3:{
        en:'→ Then left turn to Whitfield Road.',
        tc:'→ 然後左轉到威菲路街。',
        sc:'→ 然后左转到威菲路街。'
    },
    mapText:{
        en:'Google Map',
        tc:'Google地圖',
        sc:'Google地图'
    },

}